<template lang="pug">
    UniversalLink(
        v-bind="buttonEditable"
        :link="data.link"
        :openNewWindow="data.linkTarget === 'NEW_WINDOW'"
        :class="buttonClass"
    )
        BaseButton(
            :class="buttonClass"
            :color="data.fillColor"
            :buttonStyle="data.style"
            :icon="buttonIcon"
            :hasCustomTextColor="data.style !== 'OUTLINE'"
        ) {{ data.text }}
</template>

<script>
import BaseButton from '@/components/baseButton'
import UniversalLink from '@/components/universalLink'
import { bindStoryblokBridgeData, generateFontColorClass } from '../../../helpers'

export default {
    name: 'ButtonItem',
    components: {
        UniversalLink,
        BaseButton,
    },
    props: {
        data: {
            type: Object,
            default() {
                return {}
            },
        },
        mobileIsFullWidth: {
            type: String,
            default: '',
        },
        tabletIsFullWidth: {
            type: String,
            default: '',
        },
        desktopIsFullWidth: {
            type: String,
            default: '',
        },
    },
    computed: {
        buttonEditable() {
            return bindStoryblokBridgeData(this.data)
        },
        buttonIcon() {
            if (!this.data.icon || this.data.icon === 'NONE') return
            return this.data.icon
        },
        buttonClass() {
            const classes = []
            // if full/inherit, mobile is full
            if (this.mobileIsFullWidth === 'false') classes.push('w-auto')
            else classes.push('w-full')

            if (this.tabletIsFullWidth !== 'INHERIT') {
                if (this.tabletIsFullWidth === 'false') classes.push('md:w-auto')
                else classes.push('md:w-full')
            }
            if (this.desktopIsFullWidth !== 'INHERIT') {
                if (this.desktopIsFullWidth === 'false') classes.push('lg:w-auto')
                else classes.push('lg:w-full')
            }

            if (this.data.style !== 'OUTLINE')
                classes.push(generateFontColorClass(this.data.textColor))

            return classes
        },
    },
}
</script>
